import {
  borderRadius,
  componentTokens,
  shadows,
  spacing,
  typography
} from '../KestrixDesignSystem.jsx'
import { colorTokens } from '../tokens/colors.ts'
import { viewTabTokens } from './view-tab-tokens.ts'
import type {
  ViewTabSavePanelLayout,
  ViewTabSavePanelMode
} from './ViewTabSavePanel.types.ts'

export const savePanelButtonSx = {
  minHeight: componentTokens.button.height.sm,
  height: componentTokens.button.height.sm,
  py: 0,
  fontSize: typography.body.small.fontSize,
  fontWeight: typography.body.small.fontWeight,
  lineHeight: typography.body.small.lineHeight
} as const

export const savePanelPaperSx = {
  width: 300,
  maxWidth: 'calc(100vw - 32px)',
  mt: viewTabTokens.sizing.menuOffset,
  p: spacing[3],
  borderRadius: borderRadius.md,
  boxShadow: shadows.dropdown,
  border: `1px solid ${colorTokens.surface.border.subtle}`,
  overflow: 'visible'
} as const

export const savePanelStackSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing[3]
} as const

export const savePanelNetworkBannerSx = {
  backgroundColor: colorTokens.semantic.status.errorSoftEmphasis.surface,
  color: colorTokens.semantic.status.errorSoftEmphasis.text,
  border: `1px solid ${colorTokens.semantic.status.errorSoftEmphasis.border}`,
  borderRadius: borderRadius.base,
  px: spacing[3],
  py: spacing[2]
} as const

export const savePanelFooterSx = {
  display: 'flex',
  gap: spacing[2],
  justifyContent: 'flex-end',
  pt: spacing[2]
} as const

export const savePanelHeadingSx = {
  display: 'flex',
  flexDirection: 'column',
  gap: spacing[1]
} as const

export const savePanelTitleSx = {
  m: 0,
  color: colorTokens.global.brandMuted[900]
} as const

export const savePanelSubtitleSx = {
  m: 0,
  color: colorTokens.global.neutral[600]
} as const

export const submitLabel = (
  mode: ViewTabSavePanelMode,
  submitting: boolean,
  networkError: boolean,
  layout: ViewTabSavePanelLayout = 'save'
): string => {
  if (submitting) {
    return 'Saving...'
  }
  if (networkError) {
    return 'Try Again'
  }
  if (layout !== 'save') {
    return 'Save'
  }
  return mode === 'update' ? 'Update' : 'Save View'
}
